export default __webpack_public_path__ + "static/media/logoGood.313d60af.svg";